#include <packing>
varying vec2 vUV;
uniform sampler2D uSurfaceTexture;
uniform float uTime;
uniform float uFade;

void main() {
  vec4 color = vec4(
    61.0 / 255.0,
    108.0 / 255.0,
    73.0 / 255.0,
    0.5
  );

  vec2 pos = vUV * 3.5;
  pos.y -= uTime;

  vec4 WaterLines = texture2D(uSurfaceTexture, pos);
  color.rgba += WaterLines.r * 0.1;

  gl_FragColor = vec4(color.rgb, color.a *= uFade);
}
